import axios from 'axios'

const state = {
  stores: []
}

const getters = {
  getStores (state) {
    return state.stores
  }
}

const mutations = {
  setStores (state, data) {
    state.stores = data
  }
}

const actions = {
  fetchReportCsv ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/store/${data.storeId}/report/csv`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  emailReport ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/store/${data.storeId}/report/mail`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  fetchReport ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/store/${data.storeId}/report`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  fetchStoresApi ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/stores`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  fetchStores ({dispatch, state, commit, rootGetters}, data) {
    axios({
      url: process.env.API_URL + `/ws/compliance/stores`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(({data}) => {
      if ((!data || data.length === 0) && Number(process.env.GAME_ID) === 69) {
        // Game 69 (Food Protection Manager) associates stores via the user
        // payload instead of the compliance service
        const course = rootGetters['user/getCourses'][process.env.GAME_ID]
        data = course && course.stores ? course.stores : []
      }
      commit('setStores', data)
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.log('fetchStores failed:', error.response ? error.response.status : error.message)
    })
  }
  // fetchUser ({dispatch, state, commit, rootGetters}, data) {
  //   const url = data.courseId === 52 ? process.env.API_URL + `/ws/playerservice/user/${data.username}` : process.env.API_URL + `/ws/playerservice/user/${data.username}?deck=${data.courseId}`
  //   return axios({
  //     url,
  //     method: 'GET',
  //     headers: {
  //       Authorization: 'Bearer ' + rootGetters.token
  //     }
  //   })
  // },
  // newEventDetails ({dispatch, state, commit, rootGetters}, programId) {
  //   return axios({
  //     url: process.env.API_URL + `/ws/compliance/program/${programId}/new-event`,
  //     method: 'GET',
  //     headers: {
  //       Authorization: 'Bearer ' + rootGetters.token
  //     }
  //   })
  // },
  // createEvent ({dispatch, state, commit, rootGetters}, data) {
  //   commit('setPayLoading', true)
  //   return axios({
  //     url: process.env.API_URL + `/ws/compliance/program/${data.programId}/event`,
  //     method: 'POST',
  //     data: data.data,
  //     headers: {
  //       Authorization: 'Bearer ' + rootGetters.token
  //     }
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/splatReport.js